import instance from "..";
import { IResInitDownloads } from "./types/response";
import { IPayloadInitDownloads } from "./types/payload";

export const DownloadsApi = {
  init: ({ siteId }: IPayloadInitDownloads) =>
    instance.get<IResInitDownloads>(`docs/main${siteId && '?site=' + siteId}`),
};
